import Modal from './Modal';
import { useTranslation } from '../i18n';
import './HelpModal.scss';

/**
 * Modal displaying keyboard shortcuts and interaction help
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is visible
 * @param {Function} props.onClose - Callback when modal is closed
 */
function HelpModal({ isOpen, onClose }) {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('help.title')}
      maxWidth={600}
    >
      <div className="help-modal">
        <section className="help-modal__section">
          <h4 className="help-modal__section-title">{t('help.keyboardShortcuts')}</h4>
          <dl className="help-modal__shortcuts">
            <div className="help-modal__shortcut">
              <dt className="help-modal__key">
                <kbd>Escape</kbd>
              </dt>
              <dd className="help-modal__description">{t('help.escapeKey')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__key">
                <kbd>Ctrl</kbd> + <kbd>{t('help.scroll')}</kbd>
              </dt>
              <dd className="help-modal__description">{t('help.zoomKey')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__key">
                <kbd>{t('help.middleClick')}</kbd> + {t('help.drag')}
              </dt>
              <dd className="help-modal__description">{t('help.panKey')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__key">
                <kbd>{t('help.rightClick')}</kbd>
              </dt>
              <dd className="help-modal__description">{t('help.contextMenuKey')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__key">
                <kbd>?</kbd>
              </dt>
              <dd className="help-modal__description">{t('help.helpKey')}</dd>
            </div>
          </dl>
        </section>

        <section className="help-modal__section">
          <h4 className="help-modal__section-title">{t('help.interactions')}</h4>
          <dl className="help-modal__shortcuts">
            <div className="help-modal__shortcut">
              <dt className="help-modal__action">{t('help.createEvent')}</dt>
              <dd className="help-modal__description">{t('help.createEventDesc')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__action">{t('help.editEvent')}</dt>
              <dd className="help-modal__description">{t('help.editEventDesc')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__action">{t('help.resizeEvent')}</dt>
              <dd className="help-modal__description">{t('help.resizeEventDesc')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__action">{t('help.moveEvent')}</dt>
              <dd className="help-modal__description">{t('help.moveEventDesc')}</dd>
            </div>

            <div className="help-modal__shortcut">
              <dt className="help-modal__action">{t('help.projectPills')}</dt>
              <dd className="help-modal__description">{t('help.projectPillsDesc')}</dd>
            </div>
          </dl>
        </section>
      </div>
    </Modal>
  );
}

export default HelpModal;
